import { createThunk } from '@app/store/thunk'

import { handleCallback } from './ui'

/** Signs out and reloads, on the home page or, with `stay`, on the page signed out from. */
export const handleLogout = (action: Promise<void>, { stay = false }: { stay?: boolean } = {}) =>
  createThunk(async dispatch => {
    return dispatch(
      handleCallback(async () => {
        const ep = Promise.withResolvers()
        await Promise.all([
          ep.promise,
          action
            .then(() => {
              if (stay) window.location.reload()
              else window.location.replace('/')
            })
            .catch(e => {
              ep.reject(e)
              throw e
            }),
        ])
      }, true)
    )
  })
